import React from 'react';
import {Row, Col, Form, Label, Button} from "reactstrap";
import TsInterval from "../Controls/TsInterval.mjs";
import ShowSlot from "../Controls/ShowSlot.mjs";
import Lnote from "../Controls/Lnote.mjs";

const EditPrenotazione = class extends React.Component {
	constructor(props) {
		super(props);
		window.glob.slot.reset();
		this.state = {
			changed: false,
			defaultData: props.data,
			formData: JSON.parse(JSON.stringify(props.data)),
			prefix: 'prenotazione.',
			conflitto: false
		};
		this.uid = "EditPrenotazione-"+window.glob.generateUid();
		this.fieldchange = this.fieldchange.bind(this);
		this.toolbar = this.toolbar.bind(this);
		this.save = this.save.bind(this);
		this.saveButton = this.saveButton.bind(this);
		window.glob.dropStatus([ this.state.prefix+'changed', this.state.prefix+'values' ]);
		setTimeout( ()=>{ this.toolbar() } , 0);
	}
	componentDidMount() {
		window.glob.register( this.state.prefix+'changed', fieldKeyValue =>{
			this.fieldchange(fieldKeyValue);
		}, this.uid );
		window.glob.register( this.state.prefix+'conflitto', c =>{
			this.setState({ conflitto: c });
			this.toolbar();
		}, this.uid );
	}
	componentWillUnmount() {
		window.glob.unregister( [this.state.prefix+'changed',this.state.prefix+'conflitto'], this.uid );
	}
	async fieldchange(w) {
		if ( typeof w !== 'object') return;
		if ( typeof w.name !== 'string') return;
		const v = w.value;
		const revert = [];
		const formData = this.state.formData;
		switch ( w.name ) {
			case 'lnote' :
				formData.lnote = v;
				break;
			case 'start_end':
				if ( Array.isArray(v) ) {
					formData.tinizio = v[0];
					formData.tfine = v[1];
				} else {
					revert.push('tinizio','tfine');
				}
				break;
			default: break;
		}
		await window.glob.setStatus(this.state.prefix+'values', formData);
		await window.glob.trigger(this.state.prefix+'changed.'+w.name,v);
		for (let i = 0; i < revert.length; i++) {
			const k = revert[i];
			formData[k] = this.state.defaultData[k];
			formData[k] = this.state.defaultData[k];
			await window.glob.trigger(this.state.prefix+'changed.'+k,formData[k]);
		}
		this.setState({ formData: formData });
		if ( ! this.state.changed ) this.setState({ changed : true } );
		this.toolbar();
	};
	save() {
		window.glob.slot.reset();
		window.glob.api('save', this.state.formData ).then( (o)=>{
			window.glob.setStatus('operation','index');
		}).catch( (e)=>{
			console.error(e);
			window.alert("Si è verificato un errore salvando la prenotazione.\n\nProva ancora o Annulla.");
		});
	};
	toolbar( timedOut ) {
		if ( ! timedOut ) {
			setTimeout( ()=>{ this.toolbar(true) }, 100);
			return;
		}
		let tb = (
			<Button
				onClick={()=>{ window.glob.setStatus('operation','index')}}
				color={"warning"}
				className={"btn-icon"}
			>
				<i>←</i>
				<b>Annulla</b>
			</Button>
		);
		let tb2;
		if ( this.state.conflitto ) {
			tb2 = <Label>Conflitto di orario<span className={"mobile-no"}>, impossibile salvare</span></Label>;
		} else if ( this.state.changed ) {
			tb2 = (
				<Button
					onClick={()=>{ this.save() } }
					color={"success"}
					className={"btn-icon"}
					rel={"save"}
				>
					<i>✔</i>
					<b>Salva<span className={"mobile-no"}> la prenotazione</span></b>
				</Button>
			);
		} else {
			tb2 = <Label>Modifica data e ora<span className={"mobile-no"}> della prenotazione</span></Label>;
		}
		window.glob.setStatus('toolbar',tb, tb2);
	};
	saveButton() {
		if ( this.state.conflitto || ! this.state.changed ) return "";
		return(
			<Row>
				<Col lg={12} className={"pt-4 text-center"}>
					<div className={"d-inline-block"}>
						<Button
							onClick={()=>{ this.save() } }
							color={"success"}
							className={"btn-icon"}
							rel={"save"}
						>
							<i>✔</i>
							<b>Salva<span className={"mobile-no"}> la prenotazione</span></b>
						</Button>
					</div>
				</Col>
			</Row>
		);
	};
	render() {
		return (
			<Form onSubmit={(e) => { e.preventDefault() }} className={"NuovaPrenotazione"} id={this.uid}>
				<Row>
					<Col lg={3}>
						<Label>Corso di Laurea:</Label>
					</Col>
					<Col lg={8}>
						<p>{ this.state.formData.lentenomeof }{ this.state.formData.lclasse ? ' '+this.state.formData.lclasse : '' }</p>
					</Col>
				</Row>
				<Row>
					<Col lg={3}>
						<Label>Anno Accademico:</Label>
					</Col>
					<Col lg={8}>
						<p>{ this.state.formData.laa }</p>
					</Col>
				</Row>
				<Row>
					<Col lg={3}>
						<Label>Attività Didattica:</Label>
					</Col>
					<Col lg={8}>
						<p>{ this.state.formData.lofnome }{ this.state.formData.lofanno ? ` (${this.state.formData.lofanno}${this.state.formData.lcanale ? ', '+this.state.formData.lcanale:''})` : '' }</p>
					</Col>
				</Row>
				<ShowSlot
					parent={ this.state.formData }
					globPrefix={ this.state.prefix }
				/>
				<TsInterval
					parent={ this.state.formData }
					value={[this.state.formData.tinizio,this.state.formData.tfine]}
					name={"start_end"}
					globPrefix={this.state.prefix}
				/>
				<Lnote
					name={"lnote"}
					value={this.state.formData.lnote||""}
					globPrefix={this.state.prefix}
				/>
				{ this.saveButton() }
			</Form>
		);
	}
};



// const EditPrenotazione = (props) => {
// 	if ( typeof props === 'undefined' ) props = {};
// 	const [changed,setChanged] = useState(false);
// 	const [defaultData] = useState(props.data);
// 	const [uid] = useState(window.glob.generateUid());
// 	const [formData] = useState(JSON.parse(JSON.stringify(defaultData)));
// 	const [prefix] = useState('prenotazione.');
//
// 	useEffect( ()=>{
// 		window.glob.dropStatus([ prefix+'changed', prefix+'values' ]);
// 		window.glob.register( prefix+'changed', fieldKeyValue =>{ fieldchange(fieldKeyValue) }, uid );
// 		setTimeout( ()=>{ toolbar() } , 0);
// 		return ( ()=>{
// 			window.glob.dropStatus([ prefix+'changed', prefix+'values' ]);
// 		});
// 		// eslint-disable-next-line react-hooks/exhaustive-deps
// 	},[]);
//
// 	useEffect( ()=>{
// 		toolbar();
// 		// eslint-disable-next-line react-hooks/exhaustive-deps
// 	},[changed]);
//
// 	const fieldchange = async (w) =>{
// 		if ( typeof w !== 'object') return;
// 		if ( typeof w.name !== 'string') return;
// 		const v = w.value;
// 		const revert = [];
// 		switch ( w.name ) {
// 			case 'start_end':
// 				if ( Array.isArray(v) ) {
// 					formData.tinizio = v[0];
// 					formData.tfine = v[1];
// 				} else {
// 					revert.push('tinizio','tfine');
// 				}
// 				break;
// 			default: break;
// 		}
// 		await window.glob.setStatus(prefix+'values', formData);
// 		await window.glob.trigger(prefix+'changed.'+w.name,v);
// 		for (let i = 0; i < revert.length; i++) {
// 			const k = revert[i];
// 			formData[k] = defaultData[k];
// 			await window.glob.trigger(prefix+'changed.'+k,formData[k]);
// 		}
// 		if ( ! changed ) setChanged(true);
// 	};
//
// 	const save = () => {
// 		window.glob.api('save', formData ).then( (o)=>{
// 			window.glob.setStatus('operation','index');
// 		}).catch( (e)=>{
// 			console.error(e);
// 			window.alert("Si è verificato un errore salvando la prenotazione.\n\nProva ancora o Annulla.");
// 		});
// 	};
//
// 	const toolbar = () => {
// 		let tb = (
// 			<Button
// 				onClick={()=>{ window.glob.setStatus('operation','index')}}
// 				color={"warning"}
// 				className={"btn-icon"}
// 			>
// 				<i>←</i>
// 				<b>Annulla</b>
// 			</Button>
// 		);
// 		let tb2;
// 		if ( changed ) {
// 			tb2 = (
// 				<Button
// 					onClick={()=>{ save() } }
// 					color={"success"}
// 					className={"btn-icon"}
// 					rel={"save"}
// 				>
// 					<i>✔</i>
// 					<b>Salva<span className={"mobile-no"}> la prenotazione</span></b>
// 				</Button>
// 			);
// 		} else {
// 			tb2 = <Label>Modifica data e ora<span className={"mobile-no"}> della prenotazione</span></Label>;
// 		}
// 		window.glob.setStatus('toolbar',tb, tb2);
// 	};
// 	const saveButton = ( ) => {
// 		if ( ! changed ) return "";
// 		return(<Row>
// 			<Col lg={12} className={"pt-4 text-center"}>
// 				<div className={"d-inline-block"}>
// 					<Button
// 						onClick={()=>{ this.save() } }
// 						color={"success"}
// 						className={"btn-icon"}
// 						rel={"save"}
// 					>
// 						<i>✔</i>
// 						<b>Salva<span className={"mobile-no"}> la prenotazione</span></b>
// 					</Button>
// 				</div>
// 			</Col>
// 		</Row>);
// 	};
//
// 	return (
// 		<Form onSubmit={(e) => { e.preventDefault() }} className={"NuovaPrenotazione"} id={uid}>
// 			<Row>
// 				<Col lg={3}>
// 					<Label>Corso di Laurea:</Label>
// 				</Col>
// 				<Col lg={8}>
// 					<p>{ formData.lentenomeof }{ formData.lclasse ? ' '+formData.lclasse : '' }</p>
// 				</Col>
// 			</Row>
// 			<Row>
// 				<Col lg={3}>
// 					<Label>Anno Accademico:</Label>
// 				</Col>
// 				<Col lg={8}>
// 					<p>{ formData.laa }</p>
// 				</Col>
// 			</Row>
// 			<Row>
// 				<Col lg={3}>
// 					<Label>Attività Didattica:</Label>
// 				</Col>
// 				<Col lg={8}>
// 					<p>{ formData.lofnome }{ formData.lofanno ? ` (${formData.lofanno}${formData.lcanale ? ', '+formData.lcanale:''})` : '' }</p>
// 				</Col>
// 			</Row>
// 			<TsInterval
// 				value={[formData.tinizio,formData.tfine]}
// 				name={"start_end"}
// 				globPrefix={prefix}
// 			/>
// 			{ saveButton() }
// 		</Form>
// 	);
// };

export default EditPrenotazione;